import React from "react";
import { Item } from "../Item";
import DetailsSpotlight from "./DetailsSpotlight";
import { Edit, PersonOutline } from "@material-ui/icons";
import moment from "moment";
import { parsePhoneNumber } from "react-phone-number-input";
import { useTranslation } from "react-i18next";
import Tags from "./Tags";
import * as S from "./styles";

export default function Details({ customer }) {
  const { t } = useTranslation();
  const { contact, created_at } = customer;
  const { name, phone, email } = contact;

  const phoneNumber = parsePhoneNumber(`+${phone}`);

  return (
    <Item
      leftAction={<PersonOutline />}
      RightIcon={Edit}
      rightTitle={t("Customer:details.editButtonTitle")}
      title={name}
      spotlight={<DetailsSpotlight customer={customer} />}
    >
      <S.PhoneNumberInfo>
        {phone && (
          <a href={`tel://${phone}`}>
            +{phoneNumber?.countryCallingCode} {phoneNumber?.nationalNumber}
          </a>
        )}
      </S.PhoneNumberInfo>
      <S.EmailInfo>
        <a href={`mailto:${email}`}>{email}</a>
      </S.EmailInfo>
      <S.CreatedAtInfo>
        {t(`Customer:details.createdAt`, {
          date: moment(created_at).format("DD/MM/YY hh:mm"),
        })}
      </S.CreatedAtInfo>
      {customer.customer_tag_ids && <Tags />}
    </Item>
  );
}
